import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CommonEventService } from '../services/common-event.service';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-search-assist',
    templateUrl: './search-assist.component.html',
    styleUrls: ['./search-assist.component.css'],
    standalone: true,
    imports: [FormsModule]

})
export class SearchAssistComponent implements OnInit {

  @Input() fromParent:any;
  headerCheck = false;
  constructor(
    public modalService: NgbModal,
    public commonService: CommonEventService
  ) { }

  ngOnInit() {
    console.log(this.fromParent);
    /* Output:
     {prop1: "Some Data", prop2: "From Parent Component", prop3: "This Can be anything"}
    */
  }

  selectedSuggItems(selectedId:any){
    setTimeout(()=>{
      if(selectedId == 'All'){
        if(this.commonService.commonMainObj.sierraCustomRecommendations.length > 0){
          for(let itemIndx in this.commonService.commonMainObj.sierraCustomRecommendations){
            this.commonService.commonMainObj.sierraCustomRecommendations[itemIndx]['checkedModel'] = this.headerCheck?true:false;
          }
        }else if(this.commonService.commonMainObj.sierraRecommendations.length > 0){
          for(let itemIndx in this.commonService.commonMainObj.sierraRecommendations){
            this.commonService.commonMainObj.sierraRecommendations[itemIndx]['checkedModel'] = this.headerCheck?true:false;
          }
        }
      }else{
        this.headerCheck = false;
      }
    },250);
  }

  closeModal(sendData:any) {
    this.modalService.dismissAll('Save click')
  }
}
